import { Instagram, Facebook, Twitter, Youtube, Music, Link as LinkIcon } from "lucide-react";

/**
 * Detect the social platform from any URL and return a matching icon
 * component from lucide-react. Falls back to a generic link icon.
 */
export function socialPlatform(url) {
  if (!url) return null;
  let host;
  try {
    host = new URL(url.startsWith("http") ? url : `https://${url}`).hostname.toLowerCase();
  } catch {
    return { label: "Link", Icon: LinkIcon, brand: "#655e57" };
  }
  const h = host.replace(/^www\./, "");
  if (h.includes("instagram.")) return { label: "Instagram", Icon: Instagram, brand: "#c13584" };
  if (h.includes("facebook.") || h === "fb.com" || h.endsWith(".fb.com"))
    return { label: "Facebook", Icon: Facebook, brand: "#1877f2" };
  if (h.includes("twitter.") || h === "x.com" || h.endsWith(".x.com"))
    return { label: "X / Twitter", Icon: Twitter, brand: "#000000" };
  if (h.includes("tiktok.")) return { label: "TikTok", Icon: Music, brand: "#010101" };
  if (h.includes("youtube.") || h === "youtu.be" || h.endsWith(".youtu.be"))
    return { label: "YouTube", Icon: Youtube, brand: "#ff0000" };
  return { label: "Website", Icon: LinkIcon, brand: "#655e57" };
}

/**
 * Renders a pill link with a platform-appropriate icon.
 * <SocialLinkPill url="…" testId="event-social" />
 */
export default function SocialLinkPill({ url, testId, className = "", label }) {
  if (!url) return null;
  const p = socialPlatform(url) || { label: "Link", Icon: LinkIcon, brand: "#655e57" };
  const { Icon, label: platformLabel, brand } = p;
  const shown = label ?? platformLabel;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer nofollow"
      data-testid={testId}
      className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm transition hover:-translate-y-0.5 ${className}`}
      style={{
        borderColor: "var(--border-warm)",
        background: "var(--bone)",
        color: "var(--ink)",
      }}
      title={url}
    >
      <Icon className="h-4 w-4" style={{ color: brand }} />
      <span className="font-medium">{shown}</span>
    </a>
  );
}
